module.exports = __webpack_public_path__ + "static/img/ROUPS48V_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ROUPS48V_1.png
// module id = S5u5
// module chunks = 0